<template>
    <v-sheet> 
        <v-toolbar dense flat
            color="secondary">
            <v-toolbar-title>{{$t("malfaction_report_by_truck_type")}}</v-toolbar-title>
            <v-row>
                <v-spacer></v-spacer>
                <v-col cols="4">
                    <MalfactionsAutocomplete
                        :label="$t('FAILURES')"
                        outlined
                        dense
                        v-model="malfaction_id"
                        hide-details
                        background-color="white"
                        @change="handleMalfactionsChange"
                        />
                </v-col>
            </v-row>
        </v-toolbar>
        <v-simple-table dense v-if="!loading">
            <thead>
                <tr>
                    <th>{{$t("truck_type")}}</th>
                    <th>{{$t("COUNT")}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(d, i) in data" :key="i" v-ripple @click="handleClick($event, d)">
                    <td>{{d.name}}</td>
                    <td>{{d.count}}</td>
                </tr>
            </tbody>
        </v-simple-table>
        <div v-else class="pa-4">
            <v-progress-linear
                class="my-4"
                indeterminate
                color="yellow darken-2"
            ></v-progress-linear>
            <div class="text-center">{{$t("please_wait")}}</div>
        </div>
    </v-sheet>
</template>

<script>
import { getMalfactionsReportByTruckType } from './../services/reports';
import MalfactionsAutocomplete from './MalfactionsAutocomplete';
export default {
    name: "MalfactionsReportByTruckType",
    components: { MalfactionsAutocomplete },
    data() {
        return {
            data: [],
            loading: false,
            malfaction_id: null
        }
    },
    props: {
        query: Object
    },
    watch: {
        query: {
            handler() {
                this.fetchData();
                this.malfaction_id = Number(this.query.malfaction_id);
            },
            deep: true
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let resp = await getMalfactionsReportByTruckType(this.query);
            this.data = resp.data;
            this.loading = false;
        },
        handleMalfactionsChange(id) {
            this.$router.replace({path: "/reports/malfactions-report-by-truck-type", query: { malfaction_id: id }});
        },
        handleClick(e, data) {
            this.$router.push({path: "/reports/malfactions-report-by-truck", query: { malfaction_id: data.malfaction_id, truck_type_id: data.truck_type_id }});
        }
    },
    created() {
        this.malfaction_id = Number(this.query.malfaction_id);
        if(this.query.malfaction_id) this.fetchData();
    }
}
</script>

<style>

</style>